import { Row } from "@/components";

import { cn } from "@/lib/utils";

// The small dot-and-label pill the pipeline uses for a candidacy's stage or,
// in Applied, for how it got there (Resurrected, Internally Sourced, ...).
// Shared so Application Review can show the exact same badge.
export const PipelineEntryChip = ({
  dotClassName,
  label,
}: {
  dotClassName: string;
  label: string;
}) => {
  /* Render */
  const render = () => (
    <Row className="h-6 w-fit shrink-0 items-center gap-1.5 rounded-full border border-slate-300 bg-white px-2 text-[11px] font-medium text-slate-800">
      <span className={cn("h-2 w-2 shrink-0 rounded-full", dotClassName)} />
      <span className="truncate">{label}</span>
    </Row>
  );

  return render();
};
